const selectEmployeesByDeparment = (state, dep) => {
  const result = [];
  if ('employee_model' in state && state.employee_model.entities) {
    const employees = Object.keys(state.employee_model.entities);
    employees.forEach((emp) => {
      if (state.employee_model.entities[emp].department === dep) {
        result.push({ value: emp, text: state.employee_model.entities[emp].title });
      }
    });
  }
  return result;
};

export const user = state => state.user;
export const error = state => state.error;
export const refreshToken = state => state.auth.refreshToken;
export const isLogged = state => state.auth.isLoggedIn;
export const isLogging = state => state.auth.isLogging;
export const loginError = state => state.auth.loginError;
export const loginErrorMsg = state => state.auth.loginErrorMsg;
export const layout = state => state.layout;
export const getJuridicos = state => selectEmployeesByDeparment(state, 'f37b7263-cd36-44f3-8fa5-c2c64528fe72');
export const getAnalistas = state => selectEmployeesByDeparment(state, 'c8b1796a-af01-47cb-8a09-fb5e939ac498');
export const getComerciales = state => selectEmployeesByDeparment(state, 'ff7d0f1b-0e0f-4948-89bc-e145e810e0ab');
export const getFinancieros = state => selectEmployeesByDeparment(state, '4debfccf-3058-43fe-b011-6776a93422ac');
export const getOpid = (state) => {
  if (state.route && state.route.params && state.route.params.opid) {
    return state.route.params.opid;
  }
  return null;
};

export const getRoute = state => state.route;



// WEBPACK FOOTER //
// ./src/store/getters.js